import React from "react";
import { Layout } from "antd";
import { useLayoutShell } from "./LayoutShellContext";

const { Header, Content } = Layout;

export interface AppTitleLayoutProps {
  children: React.ReactNode;
}

/**
 * 应用壳：仅当子页面通过 Context 注册顶栏左右区域时渲染顶栏；主内容区 16px 内边距并撑满剩余高度。
 */
export const AppTitleLayout: React.FC<AppTitleLayoutProps> = ({ children }) => {
  const { headerRight, headerLeft } = useLayoutShell();
  const showHeader = headerLeft != null || headerRight != null;

  return (
    <Layout
      style={{
        margin: 0,
        padding: 0,
        width: "100%",
        height: "100%",
        flex: 1,
        minHeight: 0,
        maxHeight: "100%",
        background: "#fff",
        display: "flex",
        flexDirection: "column",
        boxSizing: "border-box",
        overflow: "hidden",
      }}
    >
      {showHeader ? (
        <Header
          style={{
            flexShrink: 0,
            height: 56,
            lineHeight: "56px",
            padding: "0 16px",
            margin: 0,
            background: "#fff",
            borderBottom: "1px solid #f0f0f0",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 16,
          }}
        >
          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: "flex",
              alignItems: "center",
              overflow: "hidden",
            }}
          >
            {headerLeft}
          </div>
          {headerRight ? (
            <div style={{ flexShrink: 0, marginLeft: "auto" }}>{headerRight}</div>
          ) : null}
        </Header>
      ) : null}
      <Content
        style={{
          margin: 0,
          padding: 16,
          flex: 1,
          minHeight: 0,
          background: "#fff",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <div
          style={{
            flex: 1,
            minHeight: 0,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          {children}
        </div>
      </Content>
    </Layout>
  );
};
